import Utils from '../../modules/utils/utils-js/theme/js/utils/Utils';
import * as moment from 'moment';
import OrderForm from './OrderForm';
import Tracking from './utils/Tracking';
import { LoginPageApp } from './views/LoginPage';
import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

export default class Site {
    public static MOBILE_WIDTH = 992;

    public static Tracking = Tracking;

    public static initBlogPost(): void {
        $(() => {
            const $text = $('.vblogpost__content .cmstext');
            const $headers = $('h2', $text);
            const $toc = $('.vblogpost__toc');
            const $tocul = $('ul', $toc);

            $headers.each((ix, el) => {
                const $header = $(el);
                const text = $header.text();

                const $item = $(`
                    <li><a href="#">${text}</a></li>
                `);

                $('a', $item).on('click', (e) => {
                    e.preventDefault();

                    Utils.scrollTo($header.offset().top);
                });

                $tocul.append($item);
            });

            function recalc() {
                const $items = $('li', $tocul);
                $items.removeClass('selected');

                $headers.each((ix, el) => {
                    const $header = $(el);

                    if ($(document).scrollTop() > $header.offset().top - 200) {
                        $items.eq(ix).addClass('selected');
                        return false;
                    }
                });
            }

            if ($headers.length) {
                $(window).on('resize', recalc);
                $(document).on('scroll', recalc);

                $toc.addClass('vblogpost__toc--inited');
            }
        });
    }

    public static initBlog(): void {
        const $cats = $('.vsmeblog__categories .blogcategories');
        const $items = $('.blogcategories__item', $cats);

        let rest: JQuery[] = [];

        $items.each((ix, el) => {
            if (ix > 3) {
                const $el = $(el);
                rest.push($el);

                $el.addClass('blogcategories__item--rest');
            }
        });

        const count = rest.length;

        if (count) {
            const $more = $(`
                <a class="blogcategories__item blogcategories__item--more" href="#">
                    <span class="blogcategories__title">+${count}</span>
                </a>
            `);

            $more.on('click', (e) => {
                e.preventDefault();

                for (const $el of rest) {
                    $el.show();
                }

                $more.hide();
            });

            $cats.append($more);
        }
    }

    public static initFaqPane($uid: JQuery): void {
        const $items = $('.faqpane__item', $uid);

        $items.each((ix, el) => {
            const $item = $(el);
            const $head = $('.faqpane__item-head', $item);
            const $text = $('.faqpane__item-text', $item);

            $head.on('click', (e) => {
                const opened = !$item.hasClass('faqpane__item--opened');

                $item.toggleClass('faqpane__item--opened', opened);

                if (opened) {
                    $text.slideDown();
                } else {
                    $text.slideUp();
                }
            });
        });
    }

    public static initFaq(): void {
        const $faq = $('.faq');
        const $tabs = $('.faq__tabs');
        const $groups = $('.faq__group');

        $('body').addClass('faq--initial');

        const $selector = $(`
            <button type="button" class="faq__selector">
                <div></div>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="11" viewBox="0 0 18 11" fill="none">
                    <path d="M1 1L9 9L17 1" stroke="#96FF00" stroke-width="2"/>
                </svg>
            </button>
        `);

        $selector.prependTo('.article__aside');

        for (const group of $groups) {
            const $group = $(group);
            const $gtitle = $('h2', $group);

            const $items = $('.faq__item', $group);

            $gtitle.detach();

            $gtitle.addClass('faq__tab');

            $tabs.append($gtitle);

            $gtitle.on('click', () => {
                $groups.hide();
                $group.show();
                $('h2', $tabs).removeClass('faq__tab--active');
                $gtitle.addClass('faq__tab--active');

                $('.faq__text', $items).hide();
                $('body').removeClass('faq--initial');
                $('body').addClass('faq--sub');

                $('div', $selector).text($gtitle.text());

                if (window.innerWidth <= 769) {
                    $tabs.slideUp();
                    $faq.removeClass('faq--opened');
                    $selector.removeClass('faq__selector--opened');
                }
            });

            let first = true;

            for (const item of $items) {
                const $item = $(item);
                const $head = $('.faq__head', $item);
                const $text = $('.faq__text', $item);

                $head.append(`
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="10" viewBox="0 0 18 10" fill="none">
                        <path d="M1 1L9 9L17 1" stroke="#3C3C3C"/>
                    </svg>
                `);

                $text.hide();

                $head.on('click', () => {
                    if ($item.hasClass('faq__item--active')) {
                        $text.slideUp();
                        $item.removeClass('faq__item--active');
                    } else {
                        $item.addClass('faq__item--active');
                        $text.slideDown();
                    }
                });

                if (first) {
                    $('div', $selector).text($gtitle.text());
                    first = false;
                }
            }
        }

        $selector.on('click', () => {
            $tabs.slideDown();

            $selector.addClass('faq__selector--opened');
            $faq.addClass('faq--opened');
        });

        $groups.hide();
        $groups.first().show();

        $('h2', $tabs).first().addClass('faq__tab--active');

    }

    public static onSmeAboutUs(): void {
        $(() => {
            new Swiper('.vsmeaboutus__boxes-wrap .swiper', {
                modules: [],

                slidesPerView: 1.3,

                breakpoints: {
                    768: {
                        slidesPerView: 3,
                    },
                },
            });

            new Swiper('.vsmeaboutus-timeline .swiper', {
                modules: [],

                slidesPerView: 'auto',
                spaceBetween: 20,

                centeredSlides: true,

                breakpoints: {
                    768: {
                        initialSlide: 2,
                    },
                }
            });

            const s = new Swiper('.partners__slider', {
                modules: [Autoplay],

                slidesPerView: 1,

                autoplay: {
                    delay: 2000,
                },

                breakpoints: {
                    768: {
                        slidesPerView: 'auto',
                        enabled: false,
                    },
                },
            });
        });
    }

    public static onThankyouPage(options: any): void {
        console.log(options);

        if (options.ev) {
            Site.Tracking.doEvent(options.sme ? 'b2bsme_purchase' : 'purchase', options.ev);
        }

        if (options.ufm) {
            setTimeout(() => {
                window.location.href = '/';
            }, 15 * 1000);
        }
    }

    public static onLoginPage($uid: JQuery): void {
        LoginPageApp.init($uid);
    }

    public static onOrderForm($uid: JQuery): void {
        OrderForm.initApp($uid);
    }

    public static discover($parent?: JQuery): void {
        Utils.updateElements($parent);
    }

    private static initMenu() {
        const $menu = $('.header__menu');
        const $button = $('.header__menu-button', $menu);

        $button.on('click', () => {
            $menu.toggleClass('header__menu--opened', !$menu.hasClass('header__menu--opened'));
        });

        $('body').on('click', (e) => {
            const $target = $(e.target);

            if (!$target.is($menu) && !$target.closest('.header__menu').length) {
                $menu.removeClass('header__menu--opened');
            }
        });
    }

    private static initHtml() {
        this.discover();

        const company = !!window.location.href.match(/dla-firm/) || $('body').hasClass('body--sme');
        $('.header__switch-inner a:first-child').toggleClass('header__switch-item--selected', !company);
        $('.header__switch-inner a:last-child').toggleClass('header__switch-item--selected', company);

        this.initMenu();
    }

    public static evalJs(): void {
        (<any>window)._js = (h: () => void) => {
            h();
        };

        let js = (<any>window)._jslist;

        $.each(js, (k, v) => {
            v();
        });
    }

    public static init() {
        moment.locale('pl');

        Tracking.init();

        (<any>window).Site = Site;

        $(document).ready(() => {
            Site.initHtml();

            Tracking.doPageView();
        });

        $(window).on('load', () => {
            $('body').addClass('body--loaded');

            setTimeout(() => {
                $('body').removeClass('body--loading');
                $('body').trigger('pageloaded');
            }, 1000);
        });
    }
}

Site.init();
